module.exports = __webpack_public_path__ + "static/images/calsync-landing.86b5f8c469b3edc3a0d263865972f9e4.svg";